'use client';

import { Button, Spinner } from 'react-bootstrap';
import { readMessage } from '../reviewUtils';
import ReviewCard from './ReviewCard';

export default function ReviewActionPanel({
  currentUser,
  deleteActionLabel,
  editActionLabel,
  helpfulLabel,
  isRefreshing,
  loginHref,
  messages,
  onDeleteOwnReview,
  onEditOwnReview,
  ownReviewState,
  pendingHelpfulId,
}) {
  if (!currentUser?.userNumber || !ownReviewState.hasPurchased) {
    return null;
  }

  if (ownReviewState.isReviewed && ownReviewState.review) {
    return (
      <ReviewCard
        currentUser={currentUser}
        deleteLabel={deleteActionLabel}
        editLabel={editActionLabel}
        helpfulLabel={helpfulLabel}
        onDelete={onDeleteOwnReview}
        onEdit={onEditOwnReview}
        pendingHelpfulId={pendingHelpfulId}
        review={ownReviewState.review}
        showActions
        title={readMessage(
          messages,
          'writeReview.title.edit',
          'Update Your Review',
        )}
      />
    );
  }

  return (
    <div className="product-reviews__cta product-detail-panel__summary-card">
      <span className="product-reviews__cta-icon" aria-hidden="true">
        ✍️
      </span>
      <p className="product-reviews__eyebrow">
        {readMessage(
          messages,
          'writeReview.formTitle',
          'Share Your Experience',
        )}
      </p>
      <h3>
        {readMessage(
          messages,
          'writeReview.title.new',
          'Write a Customer Review',
        )}
      </h3>
      <p className="product-reviews__cta-copy">
        {readMessage(
          messages,
          'writeReview.shareExperience',
          'Share your experience with this product.',
        )}
      </p>
      <Button
        variant="transparent"
        className="app-button app-button--primary"
        onClick={onEditOwnReview}
        disabled={ownReviewState.loading || isRefreshing}
      >
        {ownReviewState.loading ? (
          <>
            <Spinner
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
              className="me-2"
            />
            {readMessage(
              messages,
              'writeReview.loading',
              'Loading Review Form',
            )}
          </>
        ) : (
          <>
            <span
              className="product-reviews__cta-icon-inline"
              aria-hidden="true"
            >
              ⭐
            </span>
            {readMessage(messages, 'writeReview.submit.new', 'Publish review')}
          </>
        )}
      </Button>
    </div>
  );
}
